export const en = {
    direct: 'Yandex.Direct'
};
